var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import ProfileDropdown from '@backoffice/components/layout/ProfileDropdown.vue';
import { downloadFile } from '@backoffice/files/downloadFile';
import { CONFIG } from '@shared/environment/environment';
import { isCountingMode } from '@shared/utils/counting';
import { UserRole } from '@shared/types/api/user';
let Header = class Header extends Vue {
    constructor() {
        super(...arguments);
        this.isDownloading = false;
    }
    get isCountingMode() {
        return isCountingMode();
    }
    get isGanBackoffice() {
        var _a;
        return ((_a = this.$config.insurerConfig) === null || _a === void 0 ? void 0 : _a.id) === 'gan';
    }
    get hasGanExportAccess() {
        var _a;
        if (!this.$auth.loggedIn) {
            return false;
        }
        if (this.$hasAccessLevel(UserRole.ADMIN) || this.$hasAccessLevel(UserRole.MANAGER_READONLY)) {
            return true;
        }
        return ((_a = this.$auth.user) === null || _a === void 0 ? void 0 : _a.profile) === 'superviseur';
    }
    get shouldShowGanExportButton() {
        return this.isGanBackoffice && this.hasGanExportAccess;
    }
    async downloadGanExport() {
        if (this.isDownloading) {
            return;
        }
        this.isDownloading = true;
        try {
            const csvBlob = await this.$axios.$get(`${CONFIG.apiUrl}/claims/gan/export`, {
                responseType: 'blob',
            });
            const objectUrl = URL.createObjectURL(csvBlob);
            downloadFile(objectUrl, 'gan-claims.csv');
            URL.revokeObjectURL(objectUrl);
        }
        catch (error) {
            // eslint-disable-next-line no-console
            console.error('Failed to download GAN export', error);
            this.$buefy.toast.open({
                message: String(this.$t('export_csv_error')),
                type: 'is-danger',
            });
        }
        finally {
            this.isDownloading = false;
        }
    }
};
Header = __decorate([
    Component({ components: { ProfileDropdown } })
], Header);
export default Header;
